import {
    type InboxItem,
    type InboxResponse,
    type NotificationSettings
} from '@/services/notification.service'

export const useNotificationStore = defineStore('notification', () => {
    const service = useNotificationService()
    const { isMethodLoading, setLoading } = useLoading()

    const settings = ref<NotificationSettings | null>(null)
    const inbox = ref<InboxItem[]>([])
    const unreadCount = ref<number>(0)

    const fetchSettings = async (): Promise<NotificationSettings> => {
        return await setLoading('fetchSettings', async () => {
            const result = await service.getSettings()
            settings.value = result
            return result
        })
    }

    const saveSettings = async (request: NotificationSettings): Promise<NotificationSettings> => {
        return await setLoading('saveSettings', async () => {
            const result = await service.updateSettings(request)
            settings.value = result
            return result
        })
    }

    const sendTestPush = async (): Promise<void> => {
        await setLoading('sendTestPush', async () => {
            await service.sendTestPush()
        })
    }

    const fetchInbox = async (): Promise<InboxResponse> => {
        return await setLoading('fetchInbox', async () => {
            const result = await service.listInbox()
            inbox.value = result.items
            unreadCount.value = result.unreadCount
            return result
        })
    }

    const markRead = async (id: number): Promise<void> => {
        await setLoading('markRead', async () => {
            const updated = await service.markRead(id)
            const index = inbox.value.findIndex((item) => item.id === id)
            if (index !== -1 && !inbox.value[index].gelesen) {
                inbox.value[index] = updated
                unreadCount.value = Math.max(0, unreadCount.value - 1)
            }
        })
    }

    const markAllRead = async (): Promise<void> => {
        await setLoading('markAllRead', async () => {
            await service.markAllRead()
            const jetzt = new Date().toISOString()
            inbox.value = inbox.value.map((item) =>
                item.gelesen ? item : { ...item, gelesen: true, gelesenAm: jetzt }
            )
            unreadCount.value = 0
        })
    }

    return {
        settings,
        inbox,
        unreadCount,
        isMethodLoading,
        fetchSettings,
        saveSettings,
        sendTestPush,
        fetchInbox,
        markRead,
        markAllRead
    }
})
